'use client';

import { useEffect, useSyncExternalStore } from 'react';
import { FeatureFlag } from 'src/constants/feature-flag';
import { useFeatureFlagsWhenReady } from 'src/utils/use-feature-flags-when-ready';

import { registerSkewDetectors, skewRefreshController } from './index';
import { SkewRefreshBannerView } from './skew-refresh-banner-view';

const getServerState = () => 'idle' as const;

export function SkewRefreshBanner() {
  const state = useSyncExternalStore(skewRefreshController.subscribe, skewRefreshController.getState, getServerState);

  useEffect(() => registerSkewDetectors(), []);

  // Kill switch, and the operator's "force refresh now" broadcast lever. The controller
  // defaults to off, so flags never resolving leaves a manual refresh rather than an
  // unguarded auto-reload.
  useFeatureFlagsWhenReady({
    [FeatureFlag.SkewAutoReload]: (isEnabled) => {
      skewRefreshController.setAutoReloadEnabled(isEnabled);
    },
  });

  return <SkewRefreshBannerView state={state} onRefresh={skewRefreshController.refreshNow} />;
}
